import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const RouterListener = () => {
  /**
   * Hooks
   */
  const location = useLocation();
  useEffect(() => {
    /**
     * Note:
     * Will be using this listnere for segment tracking as well, hence not removing this file
     */
  }, [location]);

  /**
   * DOM
   */
  return null;
};
